import { useTranslation } from "react-i18next";

export const NoAccommodationsFound = () => {
  const { t } = useTranslation();

  return (
    <div className="noAccommodationsFoundWrap c-blank-state">
      <h4 className="u-h4">{t("noResults")}</h4>
      <p className="u-p1">{t("tryAdjustingFilters")}</p>
    </div>
  );
};
